import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { PortalCotacaoAbrirRequest } from '../../requests/compras/portal-cotacao-abrir.request';
import { PortalCotacaoResponderRequest } from '../../requests/compras/portal-cotacao-responder.request';
import { ListarTiposFreteResponse } from '../../responses/compras/listar-tipos-frete.response';
import { PortalCotacaoDetalheResponse } from '../../responses/compras/portal-cotacao-detalhe.response';
import { PortalCotacaoResumoResponse } from '../../responses/compras/portal-cotacao-resumo.response';
import { ReturnStruct } from '../../structs/return.struct';

// Portal PÚBLICO do fornecedor — endpoints anônimos (sem token de usuário).
// Não usa addHeaderToken nem o handleError global (que redireciona no 401).
@Injectable({
  providedIn: 'root',
})
export class PortalCotacaoService {
  private readonly apiUrl: string = environment.urlApiCompras + 'PortalCotacao';

  constructor(private httpClient: HttpClient) {}

  private get options(): { headers: HttpHeaders } {
    return { headers: new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' }) };
  }

  public resumo(token: string): Observable<PortalCotacaoResumoResponse> {
    return this.httpClient
      .get<PortalCotacaoResumoResponse>(`${this.apiUrl}/${token}`, this.options)
      .pipe(catchError(this.handleError));
  }

  public abrir(token: string, documento: string): Observable<PortalCotacaoDetalheResponse> {
    const request: PortalCotacaoAbrirRequest = { documento };
    return this.httpClient
      .post<PortalCotacaoDetalheResponse>(`${this.apiUrl}/${token}/abrir`, request, this.options)
      .pipe(catchError(this.handleError));
  }

  public responder(token: string, request: PortalCotacaoResponderRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/${token}/responder`, request, this.options)
      .pipe(catchError(this.handleError));
  }

  public tiposFrete(): Observable<ListarTiposFreteResponse> {
    return this.httpClient
      .get<ListarTiposFreteResponse>(`${this.apiUrl}/tipos-frete`, this.options)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const msg = error.error instanceof ErrorEvent
      ? error.error.message
      : `Código do erro: ${error.status}`;
    return throwError(() => new Error(msg));
  }
}
